import React from 'react'
import { connect } from 'react-redux'

import { fetchCoaches } from '../../../actions/admin/coaches'

import Header from './Header'
import Loading from '../../utilities/loading'
import Search from '../Search'
import CoachesTable from './CoachesTable'
import Pagination from '../Pagination'

const searchOptions = [
  { value: 'email', label: 'E-mail' },
  { value: 'firstName', label: 'First Name' },
  { value: 'lastName', label: 'Last Name' },
  { value: 'facilityName', label: 'Facility Name' },
]

const AdminCoaches = ({ loading, fetchCoaches }) => {
  React.useEffect(() => {
    fetchCoaches({
      page: 0,
      size: 10,
    })
  }, [])

  const handleFetch = (params) => {
    fetchCoaches(params)
  }

  return (
    <div className="mx-4">
      <Header />
      <div className="mb-5 small-padding">
        <Search options={searchOptions} fetchData={handleFetch} />
        {loading ? (
          <Loading />
        ) : (
          <>
            <CoachesTable />
            <div className="row mx-0 d-flex justify-content-end">
              <Pagination fetchData={handleFetch} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  fetchCoaches: (params) => dispatch(fetchCoaches(params)),
})

export default connect(null, mapDispatchToProps)(AdminCoaches)
